import React from "react"
import { LandingPageContainer, ActionButtonsGrid, ActionButton, ButtonIcon, ButtonText } from "./LandingPage.styles"

export const LandingPage = () => {
    const handleButtonClick = (buttonType: string) => {
        // Placeholder - buttons don't need correct links yet
        console.log(`Clicked ${buttonType} button`)
    }

    return (
        <LandingPageContainer>
            <ActionButtonsGrid>
                <ActionButton className="voter-btn" onClick={() => handleButtonClick("voter")}>
                    <ButtonIcon>📊</ButtonIcon>
                    <ButtonText>Voter Information</ButtonText>
                </ActionButton>

                <ActionButton className="candidates-btn" onClick={() => handleButtonClick("candidates")}>
                    <ButtonIcon>🗳️</ButtonIcon>
                    <ButtonText>Candidates</ButtonText>
                </ActionButton>

                <ActionButton className="officials-btn" onClick={() => handleButtonClick("officials")}>
                    <ButtonIcon>🏛️</ButtonIcon>
                    <ButtonText>Elected Officials</ButtonText>
                </ActionButton>

                <ActionButton className="calendar-btn" onClick={() => handleButtonClick("calendar")}>
                    <ButtonIcon>📅</ButtonIcon>
                    <ButtonText>Calendar</ButtonText>
                </ActionButton>
            </ActionButtonsGrid>
        </LandingPageContainer>
    )
}
